import {action, observable, ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {SecurableDefinition, SecurablePermission, SecurablePermissionDetail, SecurityRole} from "core/security/securityDomain";
import {observer} from "mobx-react";
import React, {CSSProperties} from "react";
import Drawer from "material-ui/Drawer";
import FlatButton from "material-ui/FlatButton";
import {lovLabel, lovValue} from "core/form/formUtils";
import {PERMISSION} from "core/metamodel/metaConstant";
import {green100, grey200, red100, white} from "material-ui/styles/colors";
import {MdCheckbox} from "core/components/fields/fields";
import {ErrorComp} from "core/components/errorComp/errorComp";


interface SecurableDetailDrawerProps {
  entities: ObservableMap<MdEntity>;
  open: boolean;
  onRequestChange: any;
  securableDefinition: SecurableDefinition;
  securablePermission: SecurablePermission;
  securityRole: SecurityRole;
}

const TH_STYLE: CSSProperties = {position: "sticky", top: 0, zIndex: 100, backgroundColor: white};
const TD_STYLE: CSSProperties = {paddingTop: 5, paddingBottom: 5};
const TD_STYLE_GREY: CSSProperties = {paddingTop: 5, paddingBottom: 5, backgroundColor: grey200};
const TD_STYLE_GREEN: CSSProperties = {paddingTop: 5, paddingBottom: 5, backgroundColor: green100};
const TD_STYLE_RED: CSSProperties = {paddingTop: 5, paddingBottom: 5, backgroundColor: red100};

@observer
export class SecurableDetailDrawer extends React.Component<SecurableDetailDrawerProps, undefined> {

  @observable expandedSPDs: SecurablePermissionDetail[];

  componentWillMount() {
    const {securableDefinition, securablePermission} = this.props;
    console.log("Open SecurableDetailDrawer ", securablePermission.securable.value);
    this.expandedSPDs = securableDefinition.detailPermissions.map(detailLov => {
      let permissionDetail: SecurablePermissionDetail = securablePermission.detailPermissions.get(lovValue(detailLov));
      if (!permissionDetail) {
        permissionDetail = new SecurablePermissionDetail({id: detailLov.value, detailId: detailLov.value, label: detailLov.label});
      }
      return permissionDetail;
    });
  }

  render() {
    let {open, securableDefinition, securityRole, securablePermission} = this.props;

    let screenWidth = document.body.getBoundingClientRect().width;
    const availablePermissions: PERMISSION[] = securableDefinition.availablePermissions;
    let permissionKeys = Object.keys(PERMISSION).filter(p => ![PERMISSION.PublicGrid, PERMISSION.TenantGrid, PERMISSION.TenantGroupGrid].includes(p as PERMISSION));

    return (
      <Drawer open={open}
              width={0.9 * screenWidth}
              docked
              onRequestChange={this.onClose}
              containerStyle={{paddingTop: 40}}
      >

        <div style={{margin: 20}}>
          <FlatButton label="Close" primary onClick={this.onClose.bind(this)}/>
        </div>

        <ErrorComp style={{margin: 20}} bsStyle="info" messages={[
          {message: "When master securable (" + lovLabel(securablePermission.securable) + ") is checked, then all detailed not checked securables are positive"},
          {message: "When master securable is not checked, then only detailed checked securables are positive"},
          {message:"In short: green ~ positive, red ~ negative"}
        ]}/>


        <table className="zz-simple-table" style={{position: "relative", margin: 10}}>
          <thead>
          <tr>
            <th style={TH_STYLE}/>
            {permissionKeys.map((p, i) => (<th key={i} style={TH_STYLE}>{p}</th>))}
          </tr>
          </thead>


          <tbody>
          <tr>
            <td style={TD_STYLE}><b>{lovLabel(securablePermission.securable)}</b></td>
            <SecurableAssignedCell expandedSPDs={this.expandedSPDs} securablePermission={securablePermission} permission={PERMISSION.Read} index={-1} availablePermissions={availablePermissions} securityRole={securityRole}/>
            <SecurableAssignedCell expandedSPDs={this.expandedSPDs} securablePermission={securablePermission}  permission={PERMISSION.New} index={-1} availablePermissions={availablePermissions} securityRole={securityRole}/>
            <SecurableAssignedCell expandedSPDs={this.expandedSPDs} securablePermission={securablePermission} permission={PERMISSION.Update} index={-1} availablePermissions={availablePermissions} securityRole={securityRole}/>
            <SecurableAssignedCell expandedSPDs={this.expandedSPDs} securablePermission={securablePermission} permission={PERMISSION.Delete} index={-1} availablePermissions={availablePermissions} securityRole={securityRole}/>
            <SecurableAssignedCell expandedSPDs={this.expandedSPDs} securablePermission={securablePermission} permission={PERMISSION.Execute} index={-1} availablePermissions={availablePermissions} securityRole={securityRole}/>
            <SecurableAssignedCell expandedSPDs={this.expandedSPDs} securablePermission={securablePermission} permission={PERMISSION.Export} index={-1} availablePermissions={availablePermissions} securityRole={securityRole}/>
            <SecurableAssignedCell expandedSPDs={this.expandedSPDs} securablePermission={securablePermission} permission={PERMISSION.Import} index={-1} availablePermissions={availablePermissions} securityRole={securityRole}/>
          </tr>
          {
            this.expandedSPDs.map((spd, index) => {
              return (
                <tr key={index}>
                  <td style={TD_STYLE}>{lovLabel(spd)}</td>
                  <SecurableDetailCell spd={spd} securityRole={securityRole} permission={PERMISSION.Read} index={index} availablePermissions={availablePermissions} securablePermission={securablePermission}/>
                  <SecurableDetailCell spd={spd} securityRole={securityRole} permission={PERMISSION.New} index={index} availablePermissions={availablePermissions} securablePermission={securablePermission}/>
                  <SecurableDetailCell spd={spd} securityRole={securityRole} permission={PERMISSION.Update} index={index} availablePermissions={availablePermissions} securablePermission={securablePermission}/>
                  <SecurableDetailCell spd={spd} securityRole={securityRole} permission={PERMISSION.Delete} index={index} availablePermissions={availablePermissions} securablePermission={securablePermission}/>
                  <SecurableDetailCell spd={spd} securityRole={securityRole} permission={PERMISSION.Execute} index={index} availablePermissions={availablePermissions} securablePermission={securablePermission}/>
                  <SecurableDetailCell spd={spd} securityRole={securityRole} permission={PERMISSION.Export} index={index} availablePermissions={availablePermissions} securablePermission={securablePermission}/>
                  <SecurableDetailCell spd={spd} securityRole={securityRole} permission={PERMISSION.Import} index={index} availablePermissions={availablePermissions} securablePermission={securablePermission}/>
                </tr>
              )
            })
          }
          </tbody>


        </table>


      </Drawer>
    )
  }

  onClose(event) {
    const {onRequestChange, securablePermission} = this.props;
    securablePermission.detailPermissions.clear();
    this.expandedSPDs.forEach(spd => {
      if (spd.getPermissionList().length > 0) {
        securablePermission.detailPermissions.set(spd.detailId, spd);
      }
    })
    onRequestChange();
  }

}


interface SecurableDetailCellProps {
  permission: PERMISSION
  index: number;
  availablePermissions: PERMISSION[];
  spd: SecurablePermissionDetail;
  securityRole: SecurityRole;
  securablePermission: SecurablePermission;
}

@observer
class SecurableDetailCell extends React.Component<SecurableDetailCellProps, undefined> {
  render() {
    const {permission, index, availablePermissions, spd, securablePermission} = this.props;
    let active = availablePermissions.includes(permission);
    const tdStyle = active ? ( (!!securablePermission.isPermission(permission) != !!spd.isPermission(permission)) ? TD_STYLE_GREEN : TD_STYLE_RED ) : TD_STYLE_GREY;
    return (
      <td style={tdStyle}>
        {
          active &&
          <MdCheckbox name={permission + index} checked={spd.isPermission(permission)}
                      onCheck={this.onCheck}/>
        }
      </td>
    )
  }

  @action onCheck = (evt, checked) => {
    const {spd, permission, securityRole} = this.props;
    console.log('onCheck checked: ' + checked);
    spd.setPermission(permission, checked);
    securityRole.$dirty = true;
  };
}

interface SecurableAssignedCellProps {
  permission: PERMISSION
  index: number;
  availablePermissions: PERMISSION[];
  securablePermission: SecurablePermission;
  securityRole: SecurityRole;
  expandedSPDs: SecurablePermissionDetail[];
}

@observer
class SecurableAssignedCell extends React.Component<SecurableAssignedCellProps, undefined> {
  render() {
    const {securablePermission, permission, index, availablePermissions} = this.props;
    let active = availablePermissions.includes(permission);
    const tdStyle = active ? TD_STYLE : TD_STYLE_GREY;
    return (
      <td style={tdStyle}>
        {
          active &&
          <MdCheckbox name={permission + index} checked={securablePermission.isPermission(permission)}
                      onCheck={this.onCheck}/>
        }
      </td>
    )
  }
  @action onCheck = (evt, checked) => {
    const {securablePermission, permission, securityRole, expandedSPDs} = this.props;
    console.log('onCheck checked: ' + checked);
    securablePermission.setPermission(permission, checked);
    expandedSPDs.forEach(spd => spd.setPermission(permission, false));
    securityRole.$dirty = true;
    securablePermission.$dirty = true;
  };
}



// WEBPACK FOOTER //
// ./src/core/security/component/SecurableDetailDrawer.tsx